import { appConfig } from '../config/appConfig';

/**
 * CHARTER (与 Mobile2 一致)：素材预览走 OSS 签名直链。
 * 禁止再包 AppFunctor `/api/media/proxy` —— 双倍云流量。
 * 正式说明见 docs/MEDIA_PROXY_CHARTER.md；勿把本开关改回 true。
 */
export const MEDIA_PROXY_FALLBACK_ENABLED = false;

export function isMediaProxyReference(rawUrl: string): boolean {
  const trimmed = rawUrl.trim();
  if (trimmed.includes('/api/media/proxy?') || trimmed.includes('/api/media/proxy/?')) {
    return true;
  }
  try {
    const parsed = new URL(trimmed.startsWith('/') ? `http://local${trimmed}` : trimmed);
    return parsed.pathname === '/api/media/proxy' || parsed.pathname === '/api/media/proxy/';
  } catch {
    return false;
  }
}

/** 若已是 media proxy URL，解出内层 OSS URL；否则原样返回。 */
export function unwrapMediaProxyUrl(rawUrl?: string | null): string | null {
  const trimmed = String(rawUrl || '').trim();
  if (!trimmed) return null;
  if (!isMediaProxyReference(trimmed)) {
    return trimmed;
  }
  try {
    const parsed = new URL(
      trimmed.startsWith('/')
        ? `${appConfig.apiBaseUrl.replace(/\/+$/, '')}${trimmed}`
        : trimmed,
    );
    const nested = String(parsed.searchParams.get('url') || '').trim();
    return nested || null;
  } catch {
    return null;
  }
}

/**
 * 预览 URL：直出 HTTPS（含已签名 OSS）。
 * 不再生成 `/api/media/proxy?url=...`。
 */
export function buildAssetPreviewUrl(rawUrl?: string | null): string | null {
  if (!rawUrl) return null;
  const trimmed = rawUrl.trim();
  if (!trimmed) return null;

  const unwrapped = unwrapMediaProxyUrl(trimmed) || trimmed;

  try {
    const parsed = new URL(unwrapped.startsWith('//') ? `https:${unwrapped}` : unwrapped);
    if (parsed.protocol === 'http:') {
      return `https://${parsed.host}${parsed.pathname}${parsed.search}`;
    }
    if (parsed.protocol === 'https:') {
      return parsed.toString();
    }
    return null;
  } catch {
    if (unwrapped.startsWith('/')) {
      return `${appConfig.apiBaseUrl.replace(/\/+$/, '')}${unwrapped}`;
    }
    return null;
  }
}
